<template>
  <div class="block-card" :id="`device-${item.uuid}`" :key="item.uuid" @click="openEblockDetail(item)">
    <!-- 顶部标题和状态栏 -->
    <div class="block-status-bar">
      <div class="block-title">
        <div>{{ item.title }}</div>
        <div class="block-uuid" v-if="showUuid">UUID: {{ item.uuid }}</div>
      </div>
      <div class="status-badges">
        <v-badge location="top right" color="#FF7867" :content="realData.alarm_count" v-if="realData.alarm_count > 0">
          <div v-if="realData.alarm_count > 0" class="warning-badge">告警</div>
        </v-badge>
        <div class="online-badge" :class="realData.is_online ? 'online' : 'offline'">{{ realData.is_online ? '在线' : '离线'
        }}</div>
      </div>
    </div>

    <!-- 主内容区域 -->
    <div class="block-content-wrapper">
      <!-- 左侧能量块图片 -->
      <div class="block-image">
        <div class="image-container">
          <img src="@/assets/images/station-monitor/detail-dialog/block-bottom.png" class="block-bottom-image"
            alt="block底部" loading="lazy" />
          <img :src="blockMainGalaxy" class="block-main-image" alt="block主体" loading="lazy" />
        </div>
        <div class="model-name">{{ realData.model }}</div>
      </div>

      <!-- 右侧信息区域 -->
      <div class="block-info">

        <DataCard class="info-row" title="工作状态" title-position="left" valueStyle="font-size: 14px;font-weight: 700">
          <template #value>
            <div class="value-wrapper">
              <div class="status-indicator" :style="{ backgroundColor: WorkStatusMap.getColor(realData.run_st) }"></div>
              <div class="value status-value" :style="{ color: WorkStatusMap.getColor(realData.run_st) }">{{
                WorkStatusMap.getText(realData.run_st, '--') }}</div>
            </div>
          </template>
        </DataCard>
        <DataCard class="info-row" title="空调状态" title-position="left" valueStyle="font-size: 14px;font-weight: 700">
          <template #value>
            <div class="value-wrapper">
              <div class="status-indicator" :style="{ backgroundColor: AirStatusMap.getColor(realData.airc_st) }"></div>
              <div class="value status-value" :style="{ color: AirStatusMap.getColor(realData.airc_st) }">{{
                AirStatusMap.getText(realData.airc_st, '--') }}</div>
            </div>
          </template>
        </DataCard>
        <DataCard class="info-row" title="消防状态" title-position="left" valueStyle="font-size: 14px;font-weight: 700">
          <template #value>
            <div class="value-wrapper">
              <div class="status-indicator" :style="{ backgroundColor: FireStatusMap.getColor(realData.alarm_level) }">
              </div>
              <div class="value status-value" :style="{ color: FireStatusMap.getColor(realData.alarm_level) }">{{
                FireStatusMap.getText(realData.alarm_level, '--') }}</div>
            </div>
          </template>
        </DataCard>

        <v-divider class="my-2" color="rgba(239, 244, 251, 0.8)" opacity="1"></v-divider>
        <DataCard class="info-row" title="实时功率" title-position="left" :value="realData.p_total" unit="kW"
          valueStyle="font-size: 14px;font-weight: 700" />
        <DataCard class="info-row" title="SOC" title-position="left" :value="realData.soc" unit="%"
          valueStyle="font-size: 14px;font-weight: 700">
          <template #value>
            <div class="value-wrapper">
              <div class="soc-progress-bar">
                <div class="soc-fill" :style="{ width: realData.soc + '%' }"></div>
              </div>
              <div class="value">{{ formatValue(realData.soc) }}%</div>
            </div>

          </template>
        </DataCard>
        <!-- 底部按钮组 -->
        <div class="block-actions">
          <!-- <div class="action-btn" @click.stop="$emit('open-eblock-detail', block)">详情</div>
                    <div class="action-btn" @click.stop="$emit('open-pcs-detail', block)">pcs</div>
                    <div class="action-btn" @click.stop="$emit('open-cluster-detail', block)">电池簇</div> -->
        </div>
      </div>
    </div>
  </div>
  <!-- {{ item }} -->
</template>




<script setup>
import { ref } from 'vue';
import { createStatusMap } from '@/utils'
import { useRouter, useRoute } from 'vue-router'
import DataCard from '@/components/DataCard/index.vue'

// 导入所有 block-main 图片
import blockMain172 from '@/assets/images/station-monitor/detail-dialog/block-main-172.png'
import blockMain200 from '@/assets/images/station-monitor/detail-dialog/block-main-200.png'
import blockMain230 from '@/assets/images/station-monitor/detail-dialog/block-main-230.png'
import blockMain250 from '@/assets/images/station-monitor/detail-dialog/block-main-250.png'
import blockMain261 from '@/assets/images/station-monitor/detail-dialog/block-main-261.png'
import blockMain372 from '@/assets/images/station-monitor/detail-dialog/block-main-372.png'
import blockMain836 from '@/assets/images/station-monitor/detail-dialog/block-main-836.png'
import blockMainGalaxy from '@/assets/images/station-monitor/detail-dialog/block-main-galaxy.png'

const router = useRouter()
const route = useRoute()

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  showUuid: {
    type: Boolean,
    default: false
  },
  realData: {
    type: Object,
    default: () => ({})
  }
})



// 0:停机 1:制热 2:制冷 3:故障
const AirStatusMap = createStatusMap({
  0: { text: '停机', color: 'var(--color-stopped)' },
  1: { text: '制热', color: 'red' },
  2: { text: '制冷', color: 'blue' },
  3: { text: '故障', color: 'red' },
  4: { text: '除湿', color: 'var(--color-primary)' },
})
// 0正常 1一级预警 2二级预警 3三级预警
const FireStatusMap = createStatusMap({
  0: { text: '正常', color: 'var(--color-success)' },
  1: { text: '一级预警', color: 'orange' },
  2: { text: '二级预警', color: 'red' },
  3: { text: '三级预警', color: 'red' },
})
// eBlock 工作状态映射 (0-7)
const WorkStatusMap = createStatusMap({
  0: { text: '空状态', color: '#9E9E9E' },
  1: { text: '停机', color: 'var(--color-stopped)' },
  2: { text: '待机', color: 'var(--color-standby)' },
  3: { text: '充电', color: 'var(--color-charging)' },
  4: { text: '放电', color: 'var(--color-discharge)' },
  5: { text: '降额', color: 'var(--color-warning)' },
  6: { text: '告警', color: 'var(--color-warning)' },
  7: { text: '故障', color: 'var(--color-error)' },
})


// block 图片映射表
const blockImageMap = {
  '172': blockMain172,
  '200': blockMain200,
  '230': blockMain230,
  '250': blockMain250,
  '261': blockMain261,
  '372': blockMain372,
  '836': blockMain836,
  'Galaxy': blockMainGalaxy
}

// 支持的 model 数字列表
const supportedModels = ['172', '200', '230', '250', '261', '372', '836', 'Galaxy']

// 根据 model 获取对应的 block 图片
const getBlockImage = (model) => {
  if (!model) return blockMain200
  // 从 model 字符串中提取数字
  const match = String(model).match(/\d+/)
  if (match) {
    const modelNumber = match[0]
    if (supportedModels.includes(modelNumber)) {
      return blockImageMap[modelNumber]
    }
  }
  // 默认返回 200
  return blockMain200
}

// 格式化数值，区分 0 和 无数据
const formatValue = (val) => {
  if (val === null || val === undefined || val === '') return '--'
  return val
}


function openEblockDetail(item) {
  router.push({
    // path: '/station-monitor/detail',
    query: {
      stationId: route.query.stationId,
      deviceId: item.uuid,
      deviceType: 'eblock'
    }
  })
}


</script>




<style scoped lang="scss">
/* 能量块网格 */
.energy-blocks-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(356px, 1fr));
  gap: 12px;
  align-content: start;
}

/* 能量块卡片 */
.block-card {
  position: relative;
  min-width: 0;
  width: 100%;
  // min-height: 207px;
  // background: rgba(239, 244, 251, 0.7);
  border-radius: 8px;
  border: 2px solid #F4F7FC;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
  /* 移除 contain 以避免内容被裁剪 */
  will-change: border-color, box-shadow;
  cursor: pointer;

  &.highlight-device {
    animation: highlightBlink 0.5s ease-in-out 6;
  }
}

.block-status-bar {
  position: relative;
  width: 100%;
  height: 48px;
  background: rgba(239, 244, 251, 0.7);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  box-sizing: border-box;
  border-radius: 6px;
}

.block-title {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 16px;
  color: rgba(46, 46, 46, 1);
  font-weight: normal;
  min-width: 0;
  overflow-wrap: anywhere;
}

.elink-uuid,
.block-uuid {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 10px;
  color: rgba(46, 46, 46, 0.6);
  font-weight: normal;
  overflow-wrap: anywhere;
}

.status-badges {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.warning-badge {
  width: 50px;
  height: 20px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 12px;
  color: rgba(46, 46, 46, 1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.online-badge {
  width: 50px;
  height: 20px;
  border-radius: 10px;
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.online {
    background: rgba(184, 229, 191, 0.28);
    color: rgba(54, 182, 12, 1);
  }

  &.offline {
    background: rgba(229, 232, 241, 1);
    color: rgba(46, 46, 46, 1);
  }
}

.block-content-wrapper {
  display: flex;
  padding: 18px 12px 0;
  flex: 1;
  min-width: 0;
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
}

.block-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 118px;
  flex-shrink: 0;
  margin-top: 2px;

  .image-container {
    position: relative;
    width: 108px;
    height: 104px;

    .block-bottom-image {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 118px;
      height: 18px;
    }

    .block-main-image {
      position: absolute;
      top: 30;
      left: 7px;
      width: 108px;
      // height: 90px;
    }
  }

  .model-name {
    margin-top: 5px;
    font-family: 'HarmonyOS Sans SC', sans-serif;
    font-size: 10px;
    color: rgba(46, 46, 46, 0.6);
    line-height: normal;
  }
}

.block-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  margin-left: 18px;
}

.info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 0;
  padding: 0;
  padding-right: 8px;

  .label {
    font-family: 'HarmonyOS Sans SC', sans-serif;
    font-size: 14px;
    color: rgba(46, 46, 46, 1);
    line-height: normal;
  }

  .value-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    min-width: 0;
  }

  .value {
    font-family: 'HarmonyOS Sans SC', sans-serif;
    font-size: 14px;
    color: rgba(46, 46, 46, 1);
    line-height: normal;
    white-space: nowrap;
  }

  .status-value {
    font-size: 14px;
  }

  .status-indicator {
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }

  .power-icon-wrapper {
    position: relative;
    width: 38px;
    height: 13px;
    margin-right: 4px;

    img {
      position: absolute;
      width: 100%;
      height: auto;
    }

    .power-icon-base {
      top: 1px;
      left: 1px;
      width: 37px;
      height: 12px;
    }

    .power-icon-overlay {
      top: 0;
      left: 0;
      width: 38px;
      height: 10px;
    }
  }

  .soc-progress-bar {
    width: 70px;
    flex-shrink: 0;
    height: 8px;
    background: rgba(239, 244, 251, 1);
    border-radius: 20px;
    overflow: hidden;
    margin-right: 4px;

    .soc-fill {
      height: 100%;
      background: linear-gradient(270deg, rgba(141, 211, 245, 1) 5.77%, rgba(184, 229, 214, 1) 52.89%, rgba(222, 248, 179, 1) 100%);
      border-radius: 20px;
      transition: width 0.3s ease;
    }
  }
}

.block-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  padding: 0 15px 20px;
  margin-top: auto;
}

.action-btn {
  width: 51px;
  height: 20px;
  background: rgba(58, 104, 255, 0.1);
  border-radius: 20px;
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 12px;
  list-style: none;
  color: rgba(58, 104, 255, 1);
  line-height: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(58, 104, 255, 0.2);
  }
}
@media (max-width: 1366px) {
  .block-status-bar {
    padding: 0 12px;
  }

  .block-title {
    font-size: 15px;
  }

  .block-content-wrapper {
    padding-left: 10px;
    padding-right: 10px;
  }

  .block-image {
    width: 108px;
  }

  .block-info {
    gap: 14px;
    margin-left: 14px;
  }
}

@media (max-width: 768px) {
  .block-content-wrapper {
    flex-direction: column;
    gap: 12px;
  }

  .block-image {
    width: 100%;
  }

  .block-info {
    margin-left: 0;
  }
}
</style>
